import axiosSecurity from '@/services/axios/axiosSecurity'

export default class AuthService {
  static async login(email, password) {
    return axiosSecurity.post('auth/login', { email, password }).then(res => res.data.data)
  }

  static async isAccessTokenValid() {
    try {
      await axiosSecurity.post('auth/validate')
      return true
    } catch {
      return false
    }
  }

  static async refreshToken(token) {
    return axiosSecurity.post('auth/refresh-token', { token }).then(res => res.data.data)
  }

  static async loginMfa(body) {
    return axiosSecurity.post('auth/login/mfa', body).then(res => res.data.data)
  }

  static async enviarEmailMfa(body) {
    return axiosSecurity.post('auth/login/mfa/email', body).then(res => res.data.data)
  }

  static async getMfaInfo() {
    return axiosSecurity.get('auth/login/mfa').then(res => res.data.data)
  }

  static async manageMfa(body) {
    return axiosSecurity.post('auth/login/mfa/manage', body)
  }

  static async enviarEmailResetSenha(body) {
    return axiosSecurity.post('auth/password/forget', body)
  }

  static async resetarSenha(body) {
    return axiosSecurity.put('auth/password/reset', body)
  }

  static async loginAgente() {
    return axiosSecurity.put('auth/agentes/login-logout', { logado: true })
  }

  static async logoutAgente() {
    return axiosSecurity.put('auth/agentes/login-logout', { logado: false })
  }

  static async logoutAgentePeloGestor(agenteId) {
    return axiosSecurity.put(`auth/agentes/${agenteId}/deslogar`)
  }
}
